<template>
    <div class="subjectBox" ref="subjectBox">
        <template v-if="is_show == 0">
            <div class="singleElection" v-for="(item, index) in questionList" :key="index"
                :class="flag !== index ? 'hide' : ''"><!--单选题-->
                <template v-if="topicSwitching">
                    <p class="singleElectionTitle" v-html="`${index + 1}:【${typeList[item.type]}】${item.title}`"></p><!--单选题的标题 -->
                    <div class="file_img">
                        <div v-for="item in item.file" :key="item.id" @click="path = item.img_path;preview = true">
                            <img :src="'/honda'+item.img_path"/>
                            {{ item.img_name }}
                        </div>
                    </div>
                    <!-- <div class="seeImg" v-if="item.file && item.file.length">
                        <Button type="primary" @click="urlList = item.file; preview = true">{{ $t('i.test.seeImg') }}</Button>
                    </div> -->
                    <template v-if="item.type == 1">
                        <RadioGroup vertical v-model="questionList[index].answer_content">
                            <template v-for="op in item.option_value">
                                <div class="singleElectionBox">
                                    <Radio :label="op.order_type" style="font-size: 18px" size="large" class="publicText">
                                    </Radio>
                                    <span class="answerText">{{ op.content }}</span>
                                </div>
                            </template>
                        </RadioGroup>
                    </template>
                    <template v-else-if="item.type == 2">
                        <CheckboxGroup v-model="questionList[index].answer_content" vertical>
                            <template v-for="op in item.option_value">
                                <div class="singleElectionBox">
                                    <Checkbox :label="op.order_type" style="font-size: 18px" size="large"
                                        class="checkboxClass">{{ op.order_type }} {{ op.content }}</Checkbox>
                                </div>
                            </template>
                        </CheckboxGroup>
                    </template>
                    <template v-else-if="item.type == 3">
                        <RadioGroup v-model="questionList[index].answer_content" vertical>
                            <template v-for="op in item.option_value">
                                <div class="singleElectionBox" style="height: 20px;">
                                    <Radio :label="op.content" style="font-size: 18px" size="large"><span
                                            class="answerText2">{{ op.content }}</span></Radio>
                                </div>
                            </template>
                        </RadioGroup>
                    </template>
                    <template v-else-if="item.type == 4">
                        <Input style="width: 350px;margin-left: 35px;" v-model="questionList[index].answer_content" />
                    </template>
                    <template v-else>
                        <Input v-model="questionList[index].answer_content" type="textarea"
                            :autosize="{ minRows: 2, maxRows: 5 }" style="margin-left: 35px;width: 450px;" />
                    </template>
                </template>
                <template v-else>
                    <p class="rightKey">{{ $t('i.test.determine') }}：{{ determine }}</p>
                    <p class="rightKey">{{ $t('i.test.answerDescr') }}：{{ is_right }}</p>
                    <p class="answerExplanation" v-html="is_right_desrc">{{is_right_desrc}}</p>
                </template>
            </div>
            <template v-if="questionList.length > 0">
                <div class="btnBox" align="center">
                    <template v-if="is_submit == 0">
                        <template v-if="questionList.length > flag + 1">
                            <Button type="success" @click="nextPage">{{ $t('i.page.next') }}</Button>
                            <Button type="error" class="preservation" v-on:click="submitTest(0)">{{
                                $t('i.test.preservation') }}</Button>
                        </template>
                        <template v-else="questionList.length ==  flag+1">
                            <!-- <Button type="success" @click="nextPage">{{ $t('i.page.next') }}</Button> -->
                            <Button type="error" class="preservation" v-on:click="submitTest(1)">{{ $t('i.test.propose')
                            }}</Button>
                        </template>
                    </template>
                    <template v-else>
                        <Button type="error" class="preservation" v-on:click="submitTest(1)">{{ $t('i.test.propose')
                        }}</Button>
                    </template>
                </div>
            </template>
        </template>
        <template v-else-if="is_show == 1">
            <div class="schoolReport">
                <p class="schoolReportText" style="color: #31C401;">{{ $t('i.test.passExamination') }}</p>
            </div>
        </template>
        <template v-else-if="is_show == 2">
            <div class="singleElection"><!--成绩单-->
                <Table :columns="columns" :data="questionList" :show-header="false" style="margin: 20px"></Table>
                <div class="allAnswers">
                    <!-- <div class="AnswerBox" v-for="(item, index) in questionList">
                        <div style="width: 60px;float: left;">
                            <span style="font-size: 20px;">{{ index + 1 }}、</span>
                        </div>
                        <template v-if="item.type == 2">
                            <span class="allAnswersText">{{ item.content }}</span>
                            <template v-if="item.is_correct_value == item.content">
                                <span class="allAnswersText">{{ $t('i.test.Yes') }}</span>
                            </template>
                            <template v-else>
                                <span class="allAnswersText">{{ $t('i.test.No') }}</span>
                            </template>
                        </template>
                        <template v-else-if="item.type == 1 || item.type == 3 || item.type == 4">
                            <span class="allAnswersText">{{ item.answer_content }}</span>
                            <template v-if="item.is_correct_value == item.answer_content">
                                <span class="allAnswersText">{{ $t('i.test.Yes') }}</span>
                            </template>
                            <template v-else>
                                <span class="allAnswersText">{{ $t('i.test.No') }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <span class="allAnswersText">{{ item.answer_content }}</span>
                        </template>
                    </div> -->
                    <div class="btnBox2" align="center">
                        <Button type="error" @click="reExamination">{{ $t('i.test.reExamination') }}</Button>
                    </div>
                    <div class="testNotPass">
                        <span>{{ $t('i.test.testNotPass') }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="is_show == 4">
            <div class="schoolReport">
                <p class="schoolReportText" style="color: #31C401;">{{ $t('i.test.saveOk') }}</p>
            </div>
        </template>
        <template v-else>
            <div class="schoolReport">
                <p class="schoolReportText" style="color: red">{{ $t('i.test.examinationValidityPeriod') }}</p>
            </div>
        </template>
        <Modal v-model="preview" width="1200" :footer-hide="true">
            <div class="imgList">
                <img :src="'/honda'+path" />
            </div>
        </Modal>
        <Spin size="large" fix v-if="loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        </Spin>
    </div>
</template>
  
<script>
import Vue from 'vue'
export default {
    name: "particularYear",
    data() {
        return {
            single: [],
            multi: [],
            judge: [],
            fill: [],
            ask: [],
            flag: 0,
            paper: '',
            is_show: '',
            topicSwitching: true,
            questionList: [],
            is_right: '',
            is_right_desrc: '',
            answer_times: '',
            makeup_type: '',
            is_update_answer: '',
            is_submit: '0',
            is_repeat: '1', //控制重复提交
            determine: '',
            nextFlag: [],
            preview:false,
            path:'',
            columns:[{
                render: (h, params) => {
                    return h('div', '第'+(params.index+1)+'题');
                }
            },{
                render: (h, params) => {
                    return h('div', params.row.type == 2 ? params.row.content: 
                    params.row.type == 1 || params.row.type == 3 || params.row.type == 4 ? params.row.answer_content : '');
                }
            },{
                key:'fuText'
            }],
            //1:单选、2:多选、3:判断、4:填空、5:识图、6:计算、7:案例分析 8：问答题 9:不定项
            typeList:{
                1: '单选',
                2: '多选',
                3: '判断',
                4: '填空',
                5: '识图',
                6: '计算',
                7: '案例分析',
                8: '问答题',
                9: '不定项'
            },
            loading:false,
        }
    },
    methods: {
        async nextPage() {
            this.nextFlag[this.flag] = false;
            if (this.questionList[this.flag].answer_content == ""
                || this.questionList[this.flag].answer_content == null) {
                this.$Message.error({
                    content: this.$t('i.exam.message'),
                    duration: 5,
                    closable: true
                });
                return false
            }
            if (this.topicSwitching === false) {
                this.flag++
            } else {
                if (this.flag + 1 == this.questionList.length) {
                    this.is_submit = '1'
                }
                this.is_right_desrc = this.questionList[this.flag].descr
                this.is_right = this.questionList[this.flag].is_correct_value
                let ff = ''
                if (this.questionList[this.flag].type == 8) {
                    this.determine = '';
                    this.questionList[this.flag].determine = "Y";
                } else {
                    if (this.questionList[this.flag].type == 2) {
                        ff = this.questionList[this.flag].answer_content.sort().join("")
                    } else {
                        ff = this.questionList[this.flag].answer_content
                    }
                    if (ff == this.is_right) {
                        this.determine = this.$t('i.test.Yes');
                        this.questionList[this.flag].determine = "Y";
                    } else {
                        this.determine = this.$t('i.test.No');
                        this.questionList[this.flag].determine = "N";
                    }
                }
            }
            this.topicSwitching = !this.topicSwitching;
            if(!this.topicSwitching && this.paper.show_answer == 0){
                this.nextPage()
            }
            this.$refs.subjectBox.scrollTop = 0
        },
        //重新考试
        async reExamination() {
            this.questionList = this.questionList.filter(item => {
                if(item.type == 2 && this.makeup_type == 'P'){
                    return item.is_correct_value != item.content
                }else if((item.type == 1 || item.type == 3 || item.type == 4) && this.makeup_type == 'P'){
                    return item.is_correct_value != item.answer_content
                }
                return item
            })
            for (let i = 0; i < this.questionList.length; i++) {
                let type = this.questionList[i].type
                if (type == 2) {
                    let aa = [];
                    this.questionList[i].answer_content = aa
                } else {
                    this.questionList[i].answer_content = ''
                }
            }
            this.is_show = "0"
            this.topicSwitching = true;
            this.flag = 0;
            this.answer_times = this.answer_times + 1;
            this.is_update_answer = '0'
            this.is_submit = '0'
            this.is_repeat = 1
            this.$refs.subjectBox.scrollTop = 0
        },
        async submitTest(status) {
            if (this.nextFlag[this.flag] == true || this.flag == 0) {
                this.is_right_desrc = this.questionList[this.flag].descr
                this.is_right = this.questionList[this.flag].is_correct_value
                let ff = ''
                if (this.questionList[this.flag].type == 8) {
                    this.determine = '';
                    this.questionList[this.flag].determine = "Y";
                } else {
                    if (this.questionList[this.flag].type == 2) {
                        ff = this.questionList[this.flag].answer_content.sort().join("")
                    } else {
                        ff = this.questionList[this.flag].answer_content
                    }
                    if (ff == this.is_right) {
                        this.determine = this.$t('i.test.Yes');
                        this.questionList[this.flag].determine = "Y";
                    } else {
                        this.determine = this.$t('i.test.No');
                        this.questionList[this.flag].determine = "N";
                    }
                }
            }
            if (this.is_repeat == 0) {
                return false;
            }
            this.is_repeat = 0
            let single = [];
            let multi = [];
            let judge = [];
            let fill = [];
            let ask = [];
            let questionListP = [];
            for (let i = 0; i < this.questionList.length; i++) {
                let data = {};
                data.question_id = this.questionList[i].question_id;
                data.answer_content = this.questionList[i].answer_content;
                data.is_correct_value = this.questionList[i].is_correct_value;
                data.score = this.questionList[i].score;
                const determineP = this.questionList[i].determine;
                data.determine = determineP;
                // if (determineP != "Y") {
                    questionListP.push(this.questionList[i]);
                // }
                let type = this.questionList[i].type;
                if (type == 1) {
                    single.push(data);
                } else if (type == 2) {
                    let tt = this.questionList[i].answer_content.join("");
                    this.questionList[i].content = tt;
                    multi.push(data);
                } else if (type == 3) {
                    judge.push(data);
                } else if (type == 4) {
                    fill.push(data);
                } else {
                    ask.push(data);
                }
                if(type == 2){
                    if(this.questionList[i].is_correct_value == this.questionList[i].content){
                        this.questionList[i].fuText = this.$t('i.test.Yes')
                    }else{
                        this.questionList[i].fuText = this.$t('i.test.No')
                    }
                }else if(type == 1 || type == 3 || type == 4){
                    if(this.questionList[i].is_correct_value == this.questionList[i].answer_content){
                        this.questionList[i].fuText = this.$t('i.test.Yes')
                    }else{
                        this.questionList[i].fuText = this.$t('i.test.No')
                    }
                }
            }

            const info = {};
            info.single = single;
            info.multi = multi;
            info.judge = judge;
            info.fill = fill;
            info.ask = ask;
            info.paper_id = this.paper.id;
            info.passing_score = this.paper.passing_score;
            info.answer_times = this.answer_times;
            info.is_show = this.is_show;
            info.makeup_type = this.makeup_type;
            if ("1" == this.is_update_answer) {
                info.is_update_answer = this.is_update_answer;
            } else {
                info.is_update_answer = "0";
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 18
                            }
                        }),
                    ])
                }
            });
            const json = await this.RequestUtil.request("/front/exam/submitTest?status=" + status, info);
            this.$Spin.hide();
            if (json) {
                this.is_repeat = 1
                this.topicSwitching = true;
                if (json.statusCode == this.Constants.statusCode.ok) {
                    if (status == "0") {
                        this.is_show = "4";
                    } else {
                        if (json.message == "1") {
                            this.is_show = "1";
                        } else {
                            this.is_show = "2";
                            if (this.makeup_type == "P") {
                                this.questionList = questionListP;
                            }
                        }
                    }
                } else {
                    this.$Message.error({
                        content: json.message,
                        duration: 3,
                        closable: true
                    });
                }
            }
        },
        async joinTest(idAndState) {
            const [id, state] = idAndState.split('-')
            // if (state == '1') {
            //     return
            // }
            this.single = [];
            this.multi = [];
            this.judge = [];
            this.fill = [];
            this.ask = [];
            this.loading = true
            const json = await this.RequestUtil.request("/front/exam/test?paper_id=" + id);
            this.loading = false
            let that = this
            if (json) {
                if (json.statusCode == this.Constants.statusCode.ok) {
                    this.questionList = json.datas.data ? json.datas.data.map(item => {
                        if(item.type == 2){
                            if(item.is_correct_value == item.content){
                                item.fuText = this.$t('i.test.Yes')
                            }else{
                                item.fuText = this.$t('i.test.No')
                            }
                        }else if(item.type == 1 || item.type == 3 || item.type == 4){
                            if(item.is_correct_value == item.answer_content){
                                item.fuText = this.$t('i.test.Yes')
                            }else{
                                item.fuText = this.$t('i.test.No')
                            }
                        }
                        return item
                    }) : [];
                    this.questionId = json.datas.questionId;
                    this.paper = json.datas.paper;
                    this.is_show = json.datas.is_show;
                    this.is_update_answer = json.datas.is_update_answer;
                    this.flag = json.datas.index;
                    this.answer_times = json.datas.answer_times;
                    this.makeup_type = json.datas.paper.makeup_type;
                    this.topicSwitching = true;
                    this.is_submit = '0'
                    this.is_repeat = 1
                    const curJsSessionId = localStorage.getItem("curJsSessionId");
                    if (this.Constants.studyCourseFlag == -1) {
                        this.Constants.studyCourseFlag = setInterval(function () {
                            let url = "/requestSes?_=" + new Date().getTime() + "&curJsSessionId=" + curJsSessionId;
                            that.RequestUtil.request(url);
                        }, 1000 * 60 * 25);//25分钟执行一次
                    }
                }
            }
        },
    },
}
</script>
  
<style scoped>
.disabled {
    color: #999;
    cursor: not-allowed;
    pointer-events: none;
    background: #19191829 !important;
}

.normalMenu {
    color: #000;
}

.main-left {
    width: 260px;
    height: 300px;
    /* margin-left: 45px; */
    /* float: left; */
}

.ivu-menu-submenu {
    background-color: #efefef;
    margin-bottom: 2px;
}

.ivu-menu-item {
    background-color: #cccaca;
    margin-bottom: 2px;
}

.specialCase {
    background: #efefef;
    pointer-events: none;
    cursor: not-allowed;
    color: #cccaca;
}

/deep/ .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    background-color: #f0faff;
    color: #000;
}






.subjectBox {
    width: 762px;
    height: 520px;
    border: 1px solid #ccc;
    margin-left: 30px;
    border-radius: 15px;
    float: left;
    position: relative;
    /* height: auto; */
    overflow-y: auto;
    overflow-x: hidden;
}

.singleElection {
    width: 758px;
    min-height: 420px;
    height: auto;
    margin: 0 auto;
}

.singleElectionTitle {
    width: 702px;
    margin: 20px;
    font-size: 18px;
}

.singleElectionBox {
    width: 670px;
    margin-left: 35px;
    margin-bottom: 30px;
}

.publicText {
    font-size: 18px;
}

.answerText {
    display: inline-block;
    white-space: normal;
    font-size: 18px;
    margin-left: 40px;
    text-indent: -2px;
    margin-top: -2px;
}

.answerText2 {
    display: inline-block;
    white-space: normal;
    font-size: 18px;
}

.ivu-radio-group-vertical .ivu-radio-wrapper {
    line-height: 22px;
    height: auto;
    position: absolute;
}

.checkboxClass {
    font-size: 18px;
}

.rightKey {
    width: 630px;
    font-size: 18px;
    margin-left: 45px;
    margin-top: 20px;
}

.answerExplanation {
    width: 630px;
    font-size: 18px;
    margin-left: 45px;
    margin-top: 20px;
}

.allAnswers {
    width: 760px;
    height: 480px;
    overflow-y: auto;
}

.AnswerBox {
    width: 630px;
    min-height: 30px;
    height: auto;
    margin-left: 100px;
    margin-top: 10px;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
}

.allAnswersText {
    font-size: 20px;
    margin-right: 30px;
}

.schoolReport {
    width: 700px;
    height: 450px;
    margin: 20px auto;
}

.schoolReportText {
    font-size: 30px;
    text-align: center;
    margin-top: 20%;
}

.btnBox {
    width: 762px;
    height: 50px;
}

.btnBox2 {
    width: 762px;
    height: 38px;
}

.testNotPass {
    /* position: absolute;
    left: 300px;
    top: 200px;
    float: left; */
    margin-top:20px;
    text-align: center;
}

.testNotPass span {
    font-size: 20px;
    font-weight: 700;
}

.preservation {
    margin-left: 15px;
}

.hide {
    display: none;
}
.seeImg{
    text-align: right;
    margin-right:20px;
}
.imgList{
    display: flex;
    justify-content: center;
    align-items: center;
}
.imgList img{
    max-width:100%;
}
.file_img{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin:0 20px 20px;
    font-size: 14px;
}
.file_img>div{
    width:49.5%;
    text-align:center;
    cursor:pointer;
}
.file_img img{
    margin-bottom:10px;
    width:100%;
    height:200px;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/test/components/topic.vue